import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import { Button, Form, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { postComment } from '../redux/actions';
import {authSelector} from "../redux/selectors";
import {hasGroup} from "./permissions";

class QuillForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            text: '',
            sec: this.props.minSecurity
        };
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(value) {
      this.setState({ text: value })

    }

    handleSubmit() {
        this.props.postComment(this.state.text, this.props.api, this.state.sec);
        // Naive clear
        this.setState({text: ''})
    }

    setSecurityLevel(level) {
        this.setState({sec: level})
    }

    modules = {
        toolbar: [
            [{'header':1}, {'header':2}],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'video'], //removed 'image' since it jams it into the db TODO make this upload to django with a custom quill handler
            [{ 'color': [] }],
            ['clean']
        ],
    };

    render() {
        if (this.props.auth.loggedIn) {
            return (
                <div>
                    <ReactQuill
                        value={this.state.text}
                        modules={this.modules}
                        onChange={this.handleChange}
                        placeholder="Write a comment..."

                    />
                    <div className="clearfix">
                        <Form inline className="pull-right">
                        <DropdownButton title={this.state.sec} id="restrictionLevel">
                            { this.props.minSecurity === 'Public' ? <MenuItem eventKey="1" onClick={() => this.setSecurityLevel('Public')}>Public</MenuItem> : null }
                            { hasGroup('Member', this.props.auth.groups) ? <MenuItem eventKey="2" onClick={() => this.setSecurityLevel('Member')}>Member</MenuItem> : null }
                            { hasGroup('Officer', this.props.auth.groups) ? <MenuItem eventKey="3" onClick={() => this.setSecurityLevel('Officer')}>Officer</MenuItem> : null }
                        </DropdownButton>
                        <Button disabled={!this.state.text} onClick={() => this.handleSubmit()}
                                type="button">Post Comment</Button>
                        </Form>
                        <h3 style={{marginTop:'15px'}}>{this.props.count} comments</h3>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <h3>{this.props.count} comments</h3>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    postComment: (comment, api, security) => dispatch(postComment(comment, api, security)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuillForm);



// WEBPACK FOOTER //
// ./src/common/QuillForm.js